import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { warehouseexecApi, type Dock } from '../../api/warehouseexec';

export function DockDashboardPage() {
  const [docks, setDocks] = useState<Dock[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    void warehouseexecApi.docks().then(setDocks).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/warehouse" className="text-sm text-slate-600 hover:underline">← Warehouse hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Dock dashboard</h1>
      {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {docks.map((d) => (
          <div key={d.id} className="rounded-xl border p-4">
            <p className="font-semibold">{d.code}</p>
            <p className="text-sm text-slate-600">Status: {d.status}</p>
            <p className="text-sm text-slate-600">Carrier: {d.carrier || '—'}</p>
          </div>
        ))}
        {!docks.length && <p className="text-sm text-slate-500">No docks registered for this warehouse.</p>}
      </div>
    </div>
  );
}
